import { gql } from "apollo-boost";
const authRoles = gql`
  query authRoles {
    authRoles {
      id
      name
      permissions {
        resId
        optIds
      }
      sortOrder
    }
    authResources {
      id
      pid
      name
      code
      operations {
        name
        code
      }
      sortOrder
    }
  }
`;

const saveAuthRole = gql`
  mutation saveAuthRole($input: AuthRoleInput!) {
    saveAuthRole(input: $input)
  }
`;

const delAuthRole = gql`
  mutation delAuthRole($id: String!) {
    delAuthRole(id: $id)
  }
`;

export const roleGql = { authRoles, saveAuthRole, delAuthRole };
